/**
 * サイドメニューコンポーネント
 */
angular.module('inspinia').directive('codmonSidemenu', () => {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    templateUrl: `/manage/src/view/directive/codmon-ui/codmon_sidemenu.html?${new Date().getTime()}`,
  };
});
